import { Button, Card, CardContent, CardFooter, Image } from "@/components/ui";
import { useClientReferralCodeQuery } from "@/gqlhooks/client/useClientReferralCodeQuery";
import { Badge } from "@/components/ui/badge";
import { View } from "@/components/ui/view";
import { Typography } from "@/components/shared/typography";
import { IconButton } from "@/components/ui/icon-button";
import { copyClipboard } from "@/lib/helpers/copy-clipboard";
import { useSharerModalStore } from "@/store/sharer";
import ReferralBannerSparkling from "@/assets/images/banner-referral-sparkling.png";
import GiftIcon from "@/assets/images/3d-icons/gift.png";
import { ImageBackground } from "@/components/ui/image-background";
import { Divider } from "@/components/shared/divider";
import { useRoute } from "@/components/shared/router";
import { useWindowDimensions } from "@/components/hooks/use-window-dimension";
import { useAuth } from "@/components/shared/auth-provider";

export function AccountMyReferralBanner() {
  const { code, loading } = useClientReferralCodeQuery();
  const { isAuthenticated } = useAuth();
  const { setOpen } = useSharerModalStore();
  const { push } = useRoute();
  const { isMobile } = useWindowDimensions();
  const referralCode = code || "";
  const isCopyDisabled = loading || !referralCode;

  const handleMyReferralClick = () => {
    if (!isAuthenticated) {
      push({ pageKey: "login" });
      return;
    }
    push({ pageKey: "accountMyReferral" });
  };

  const handleShareClick = () => {
    if (!isAuthenticated) {
      push({ pageKey: "login" });
      return;
    }
    setOpen(true);
  };

  const handleCopyClick = () => {
    if (!isAuthenticated) {
      push({ pageKey: "login" });
      return;
    }
    if (isCopyDisabled) return;
    copyClipboard(referralCode);
  };

  return (
    <ImageBackground
      src={ReferralBannerSparkling}
      className="relative rounded-lg"
      gap={0}
      position="center"
      padding={0}
    >
      <Card className="border-0 bg-transparent">
        <CardContent className="pb-3">
          <View className="flex flex-row items-center gap-3">
            <View className="h-14 w-14">
              <Image src={GiftIcon} className="h-full w-full" />
            </View>
            <View className="flex flex-1 flex-col gap-1">
              <Typography variant="label-sm" color="white">
                Give $15, Get $15
              </Typography>
              <Typography variant="caption-md" color="white">
                Every friend you refer gets $15 off their first booking and you
                get $15
              </Typography>
            </View>
          </View>
        </CardContent>
        <Divider className="mx-4 bg-brand-on-primary opacity-25" />
        <CardFooter
          className={`flex flex-row gap-2 pt-3 ${
            isAuthenticated ? "justify-between" : "justify-end"
          }`}
        >
          {isAuthenticated && (
            <Badge
              variant="over-static"
              shape="chip"
              size={isMobile ? "md" : "lg"}
              outline={false}
            >
              <View className="flex flex-row gap-2" onClick={handleCopyClick}>
                <Typography variant="body-sm" color="white">
                  {loading ? "..." : referralCode}
                </Typography>
                <IconButton
                  variant="ghost"
                  iconName="copy"
                  className="p-0"
                  size={"md"}
                  color="white"
                  disabled={isCopyDisabled}
                  onClick={handleCopyClick}
                />
              </View>
            </Badge>
          )}
          <View className="flex flex-row gap-2">
            <Button
              variant="tertiary"
              color="CTA2"
              size={isMobile ? "xs" : "sm"}
              className="px-3"
              rounded="full"
              disabled={loading}
              onClick={handleMyReferralClick}
            >
              See my referral
            </Button>
            <Button
              variant="primary"
              color="CTA"
              size={isMobile ? "xs" : "sm"}
              rounded="full"
              className="px-3"
              disabled={loading}
              onClick={handleShareClick}
              iconAlignment={"end"}
              iconName="shareFat"
              iconColor="white"
              iconSize={"md"}
            >
              Share
            </Button>
          </View>
        </CardFooter>
      </Card>
    </ImageBackground>
  );
}
